import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  print() {
    // Créer un iframe caché pour imprimer le PDF
    const iframe = document.createElement("iframe")
    iframe.style.display = "none"
    iframe.src = this.urlValue
    
    document.body.appendChild(iframe)
    
    iframe.onload = () => {
      // Attendre un peu que le PDF soit rendu
      setTimeout(() => {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
      }, 500)
    }
  }
}
